import React, { useContext, useState } from "react";
import "./webinarLandingPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import AbuotUs from "../../assets/images/new/media.png";
import ContavtImg from "../../assets/images/new/mainimg.png";
import Pitrupaksh from "../../assets/images/new/pitrupaksha-webinar.png";
import Abuotws from "../../assets/images/new/media-two.png";
import "swiper/css";
import "swiper/css/navigation";

import batuk from "../../assets/images/new/fav-removebg-preview.png";
import whyChooseUsImg from "../../assets/images/new/whyChooseUs.png";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import { useNavigate } from "react-router-dom";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import LazySection from "../Home/LazySection";
import FAQSection from "../../Components/FAQSection/FAQ";
import mainLogo from "../../../src/assets/images/new/logo.png";
import { WebinarUser } from "../../ApiServices/Webinar/WebinarApi";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import axios from "axios";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { Helmet } from "react-helmet-async";
import RazorpayWebinarPaymentButton from "./RazorpayWebinarPaymentButton";
import ComingSoonModal from "../../Components/ComingSoonModal";

const AshtaLakshmiHomamWebinar = () => {
  const { setLoader } = useContext(LoaderContext);
  const slides = [
    {
      image: "../../assets/images/new/aboutPageImg.png",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "85%",
      goal: "$23,000 Goals",
      donated: "$9,000 Donate",
      color: "#ffa415",
      shape: "assets/images/shapes/d-shape-1.png",
    },
    {
      image: "assets/images/donation/donation-1-2.jpg",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "80%",
      goal: "$13,000 Goals",
      donated: "$5,000 Donate",
      color: "#ff5528",
      shape: "assets/images/shapes/d-shape-2.png",
    },
    // Add more slides here if needed
  ];
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const [contactData, setContactData] = useState({
    email: null,
    LastName: null,
    email: null,
    mobileNumber: null,
    Message: null,
  });
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);

  const metaDataDetails = {
    MetaTitle:
      "Book Ashtalakshmi Homam Puja Webinar Online | Myomnamo",
    MetaDescription:
      "Book this Ashtalakshmi Homam puja online and join the Webinar to experience spiritual blessings and prosperity from Goddess Lakshmi.",
    OpenGraphTag:
      "Myomnamo Presents Webinar: Book Ashtalakshmi Homam Puja Webinar Online | Myomnamo",
    CanonicalTag: "https://myomnamo-new.vercel.app/ashtalakshmi-homam-webinar",
  };

  function onCaptchaChange(value) {
    console.log("Captcha value:", value);
    setVerified(true);
  }

  const handleContactFormSubmit = () => {
    let isValid = false;
    if (
      contactData.fullName === "" ||
      contactData.fullName === undefined ||
      contactData.fullName === null ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.mobileNumber === "" ||
      contactData.mobileNumber === undefined ||
      contactData.mobileNumber === null ||
      contactData?.mobileNumber?.length !== 10 ||
      // contactData.Message === "" ||
      // contactData.Message === undefined ||
      // contactData.Message === null ||
      contactData.email === "" ||
      contactData.email === undefined ||
      contactData.email === null
    ) {
      isValid = true;
      setError(true);
    } else if (
      contactData.email !== null &&
      !validateEmail(contactData.email)
    ) {
      isValid = true;
      setError(true);
    }

    const api_params = {
      fullName: contactData.fullName,
      LastName: contactData.LastName,
      email: contactData.email,
      mobileNumber: contactData.mobileNumber,
      Message: contactData.Message,
    };

    if (!isValid) {
      handleRazorpayPayment();
    }
  };

  const WebinarUserData = async (api_params) => {
    try {
      const res = await WebinarUser(api_params);

      if (res.ResponseMessage === "Success.") {
        navigate("/thank-you", {
          state: { moduleName: "ContactUs" },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeAll = () => {
    // debugger;
    setShowSuccessPopUp(false);
    setInitialData();
  };

  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      fullName: "",
      LastName: "",
      email: "",
      mobileNumber: "",
      Message: "",
    }));
  };
  //   const WebinarUserData = (params) => {
  //     const templateParams = {
  //       Name: params.name,
  //       email: params.email,
  //       "Mobile Number": params.mobileNo,
  //       message: params.message,
  //       //   to_name: "Velvet Admin",
  //       //   from_name: "Velvet mail service",
  //       //   receiver_email: "velvetgps@gmail.com",
  //     };

  //     emailjs
  //       .send(
  //         "service_wp19bkh", // Service ID
  //         "template_b9wrsrm", // Template ID
  //         templateParams, // Template Parameters
  //         "e5YUU5XlmWckFjZk_" // Public Key
  //       )
  //       .then(
  //         () => {
  //           console.log("SUCCESS!");
  //           setShowThanksModal(true);
  //         },
  //         (error) => {
  //           console.log("FAILED...", error.text);
  //         }
  //       );
  //   };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    if (id === "fullName" || id === "lastName") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (id === "mobileNumber") {
      value =
        value.charAt(0) >= "6" ? value.replace(/\D/g, "").slice(0, 10) : ""; // Only keep digits and slice to 10 digits
    }

    setContactData((prev) => ({ ...prev, [id]: value }));
  };

  const handleRazorpayPayment = async () => {
    let orderIDReturned = null;
    setLoader(true);
    const PlaceOrderResponse = await handleProceedRemainingPayment("51");
    console.log("PlaceOrderResponse", PlaceOrderResponse);

    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/Webinar/WebinarUser`, {
          Name: contactData.fullName,
          EmailID: contactData.email,
          WhatsappNumber: contactData.mobileNumber,
          WebinarFee: 51,
          PaymentStatus: true,
          TransactionID: PlaceOrderResponse?.razorpay_payment_id,
        })
        .then((res) => {
          if (res) {
            console.log(res);

            orderIDReturned = res.data.ID;
            setLoader(false);
            // navigate("/thank-you", {
            //   state: { moduleName: "WebinarPage" },
            // });
            setInitialData();
            setShowComingSoonModal(true);
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false);
      alert("Payment Failed !");
    }
  };

  const HandleJoinNowClicked = () => {
    window.open("https://rzp.io/rzp/8nIcgapm", "_blank");
  };
  const WebpageSchema ={
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Book Ashtalakshmi Homam Puja Webinar Online | Myomnamo",
  "url": "https://myomnamo-new.vercel.app/ashtalakshmi-homam-webinar",
  "description": "Book this Ashtalakshmi Homam puja online and join the Webinar to experience spiritual blessings and prosperity from Goddess Lakshmi.",
  "image": "https://myomnamo-new.vercel.app/static/media/pitrupaksha-webinar.d7f242ad56147b7da5e5.png"
}
  const BreadcrumbsSchema={
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Book Ashtalakshmi Homam Puja Webinar Online | Myomnamo",
  "url": "https://myomnamo-new.vercel.app/ashtalakshmi-homam-webinar",
  "description": "Book this Ashtalakshmi Homam puja online and join the Webinar to experience spiritual blessings and prosperity from Goddess Lakshmi.",
  "image": "https://myomnamo-new.vercel.app/static/media/pitrupaksha-webinar.d7f242ad56147b7da5e5.png"
}
  const FAQSSchema={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the date and time of the Ashtalakshmi Homam?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The homam will be performed on Saturday, 27 September 2025, from 4:00 pm to 6:00 pm (IST)."
      }
    },
    {
      "@type": "Question",
      "name": "Where is the homam taking place?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The ritual will be held at Sri Etteluthuperumal Gaushala, Tirunelveli, Tamil Nadu. Devotees can participate online from anywhere."
      }
    },
    {
      "@type": "Question",
      "name": "How much does it cost to book a family participation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The booking charge is ₹750 per family, which includes inclusion of your family names in the sankalpa (prayer) and access to the live stream."
      }
    },
    {
      "@type": "Question",
      "name": "How do I join the live stream on the day of the event?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "After completing your booking, you will receive a confirmation email or WhatsApp message containing the secure live-stream link."
      }
    },
    {
      "@type": "Question",
      "name": "Can I send my details for sankalpa if I cannot attend live?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Even if you cannot watch live, you can share your family names and gotra details during booking."
      }
    }
  ]
}  





  return (
    <>
      <Helmet>
        <title>{metaDataDetails?.MetaTitle}</title>
        <meta name="description" content={metaDataDetails?.MetaDescription} />
        <link rel="canonical" href={metaDataDetails?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={metaDataDetails?.OpenGraphTag} />
        <meta
          property="og:description"
          content="Celebrate Ganeshotsav with devotion & knowledge. Join our webinar to learn step-by-step Ganesh Puja rituals & traditions."
        />
        <meta property="og:image" content="" />
        <meta property="og:url" content={`https://www.myomnamo.com/webinar`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaDataDetails?.MetaTitle} />
        <meta
          name="twitter:description"
          content={metaDataDetails?.MetaDescription}
        />
     {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(WebpageSchema)}
        </script>
         <script type="application/ld+json">
          {JSON.stringify(BreadcrumbsSchema)}
        </script>
         <script type="application/ld+json">
          {JSON.stringify(BreadcrumbsSchema)}
        </script>
         <script type="application/ld+json">
          {JSON.stringify(FAQSSchema)}
        </script>

        <script>
          {`
            !function(f,b,e,v,n,t,s){
              if(f.fbq) return; 
              n=f.fbq=function(){n.callMethod ? 
              n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
              if(!f._fbq) f._fbq=n;
              n.push=n; n.loaded=!0; n.version='2.0';
              n.queue=[]; t=b.createElement(e); t.async=!0;
              t.src=v; s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '24982247501377559');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=24982247501377559&ev=PageView&noscript=1"/>`}
        </noscript>
      </Helmet>

      {/* <section className="about-three">
        <div className="sec-title text-center" style={{ paddingBottom: "0px" }}>
          <h6
            className="sec-title__tagline"
            style={{
              perspective: "400px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img className=" tagline-img" src={batuk} alt="" /> Webinar Topic:

         
          </h6>
          <h3
            className="sec-title__title"
            style={{
              perspective: "400px",
              textAlign: "center",
              marginBottom: "50px",
            }}
          >
         The webinar is divided in to below 2 topics.

          </h3>
        </div>
        <div className="container">
            
          <div className="row">
            <div className="col-lg-8 wow fadeInLeft" data-wow-delay="100ms">
              <div className="about-three__content">
               
                <p
                  className="about-three__content__text text-dark"
                  style={{ textAlign: "justify" }}
                >
                 <ul className="text-muted ps-4">
                        <li>The main rituals of Ganesh Chaturthi: Pranapratishhtha (invoking life into the idol), Shhodashopachara (16 types of offerings), Uttarpuja (farewell ritual), and Ganpati Visarjan (immersion of the idol).
</li>
                        <li>Step-by-step explanation of the puja vidhi, including significance and meanings behind each ritual gesture
</li>
                        
                      </ul>
                </p>
               
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className=""
                data-wow-delay="200ms"
                style={{
                  paddingTop: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="about-three__image__shape-one">
                 
                </div>
                <img src={whyChooseUsImg} className="height2" alt="careox" />
                <div
                  className="about-three__image__right wow fadeInUp"
                  data-wow-delay="300ms"
                >
                 
                </div>
                <div className="about-three__image__shape-two">
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <header className="navbar">
        <div className="container">
          <div className="navbar-logo">
            <img src={mainLogo} alt="Logo" />
          </div>
          {/* <nav className="nav-links">
            <span>वेबिनार बघा</span>
            <span>फायदे</span>
            <span>नोंदणी</span>
          </nav> */}
          {/* <div className="nav-buttons">
            <button className="register-btn">आता नोंदणी करा</button>
            <button className="lang-btn">मराठी</button>
            <button className="lang-outline">English</button>
          </div> */}
        </div>
      </header>

      <section className="pitru-section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Content */}
            <div
              className="col-lg-7 mb-4 mb-lg-0 wow fadeInLeft pitru-left"
              data-wow-delay="100ms"
            >
              <div className="pitru-content">
                {/* Title */}
                <h3 className="pitru-title">Ashtalakshmi Homam</h3>
                <p className="pitru-subtitle">
                  Ashtalakshmi Homam offers a wide range of benefits, including
                  financial abundance, overall prosperity, success in endeavors,
                  improved health and well-being, and increased peace and
                  harmony in both personal and family life. The ritual invokes
                  the eight forms of Goddess Lakshmi to grant devotees eight
                  types of wealth, such as knowledge, courage, and progeny,
                  while also eliminating obstacles, fostering spiritual
                  connection, and improving mental and emotional states.
                </p>

                {/* Details */}
                <div className="pitru-info-boxes">
                  {/* Details Box */}
                  <div className="pitru-details-card">
                    <ul className="pitru-list">
                      <li>
                        <i className="fa-solid fa-calendar"></i>{" "}
                        <span className="boldcolor"> Date : </span> 27 September
                        2025
                      </li>
                      <li>
                        <i className="fa-solid fa-clock"></i>
                        <span className="boldcolor"> Time : </span> 4:00 pm –
                        6:00 pm
                      </li>
                      <li>
                        <i className="fa-solid fa-laptop"></i>
                        <span className="boldcolor"> Attend : </span>Through the
                        live-streaming link.
                      </li>
                      <li>
                        <i className="fa-solid fa-language"></i>
                        <span className="boldcolor">Booking Charges: </span>₹
                        750/- per family.
                      </li>
                      {/* <li>
                        <i className="fa-solid fa-laptop"></i>{" "}
                        <span className="boldcolor">प्लॅटफॉर्म : </span> झूम
                      </li> */}
                    </ul>
                  </div>

                  {/* Price Box */}
                  {/* <div className="pitru-price-card">
                    <span className="pitru-price-label"><br></br>Charges</span>
                    <span className="pitru-price">₹ 750 </span>
                  </div> */}
                </div>
                <button
                  type="submit"
                  onClick={() => HandleJoinNowClicked()}
                  className="careox-btn pitru-button"
                >
                  <i
                    className="fa-solid fa-user-plus"
                    style={{ marginRight: "8px" }}
                  ></i>
                  <span className="pitrupakshabut">Book Ashtalakshmi Homam Now
</span>
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-5 pitru-right wow fadeInRight">
              <div className="pitru-image">
                <img src={Pitrupaksh} alt="Pitru Paksha Ritual" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="contact-section-custom py-5 mobile-secone">
        <div className="container">
          <div className="row align-items-center">
          
            <div
              className="col-lg-6 mb-4 mb-lg-0 wow fadeInLeft main-topicwebinar"
              data-wow-delay="100ms"
            >
              <div className="about-three__content">
                <img
                  src={ContavtImg}
                  alt="Pitru Paksha Ritual"
                  className="maincontactimg"
                />
              </div>
            </div>

          
            <div className="col-lg-6">
              <div className="form-card shadow-sm rounded bg-white padding-webinar">
                <div className="row gy-3">
               
                  <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                    संपर्क माहिती
                  </h3>

                
                  <div className="col-md-12 col-webinar">
                    <label className="form-label-custom webinar-label">
                      पूर्ण नाव <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      value={contactData?.fullName}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="पूर्ण नाव टाका"
                      maxLength={50}
                    />
                    {error &&
                    (contactData?.fullName === null ||
                      contactData?.fullName === undefined ||
                      contactData?.fullName === "") ? (
                      <span
                        className="text-danger "
                        style={{ fontSize: "14px" }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

               
                  <div className="col-md-6 col-webinar">
                    <label className="form-label-custom webinar-label">
                      व्हॉट्सॲप क्रमांक <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="mobileNumber"
                      value={contactData?.mobileNumber}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      maxLength={10}
                      placeholder="व्हॉट्सॲप क्रमांक टाका"
                    />
                    {error &&
                    (contactData?.mobileNumber === null ||
                      contactData?.mobileNumber === undefined ||
                      contactData?.mobileNumber === "") ? (
                      <span
                        className="text-danger "
                        style={{ fontSize: "14px" }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : error &&
                      contactData?.mobileNumber !== null &&
                      contactData?.mobileNumber !== "" &&
                      contactData?.mobileNumber !== undefined &&
                      contactData?.mobileNumber?.length !== 10 ? (
                      <span
                        className="text-danger"
                        style={{ fontSize: "14px" }}
                      >
                        अवैध मोबाईल क्रमांक
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

                 
                  <div className="col-md-6 col-webinar">
                    <label className="form-label-custom webinar-label">
                      ई-मेल <span>*</span>
                    </label>
                    <input
                      value={contactData?.email}
                      type="email"
                      id="email"
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="ई-मेल आयडी टाका"
                    />
                    {error &&
                    (contactData?.email === null ||
                      contactData?.email === undefined ||
                      contactData?.email === "") ? (
                      <span
                        className="text-danger"
                        style={{ fontSize: "14px" }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : error &&
                      contactData?.email !== null &&
                      contactData?.email !== undefined &&
                      contactData?.email !== "" &&
                      !validateEmail(contactData?.email) ? (
                      <span
                        className="text-danger"
                        style={{ fontSize: "14px" }}
                      >
                        अवैध ई-मेल आयडी
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

               
                <div className="mt-0 text-start">
                  <button
                    type="submit"
                    className="careox-btn wbinar-form submit-button"
                    onClick={() => handleContactFormSubmit()}
                  >
                    <span>सबमिट करा</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

     
      {/* End of Donate Section */}
      {/* <section className="shraddha-area py-5">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha-mahiti">
            मुख्य श्राद्ध खालीलप्रमाणे
          </h2>
          <p className="sub-heading pitrru-subheading--mahiti">
            आमच्या द्वारे आयोजित श्राद्ध पूजा आपल्या पितरांच्या शांतीसाठी आणि
            कुटुंबाच्या मंगलकामनेसाठी केली जाते.
          </p>
        </div>
        <div className="container">
          <div className="row">
         
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>१. भरणी श्राद्ध</h4>
                <p>
                  नुकत्याच देह्कार्य झालेल्या म्हणजे चालू वर्षातच मृत पावलेल्या
                  व्यक्तींसाठी भरणी श्राद्ध घातले जाते. पितृपक्षामधील चतुर्थी
                  किंव्हा पंचमीला भरणी नक्षत्रावर हे कार्य पूर्ण केले जाते. हे
                  श्राध्द केल्याने मृतआत्म्यास शांती मिळून त्यांची भौतिकतेच्या
                  मोहजालातून सुटका होते. या विधी मुळे गया श्राद्धासारखे पुण्य
                  मिळतेअसे म्हंटले जाते.
                </p>
              </div>
            </div>

          
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>२. हिरण्य श्राद्ध</h4>
                <p>
                  ज्या श्राद्धात शास्त्रोत विधी पूर्ण करण्यासाठी यजमान शिजवलेले
                  अन्न देऊ शकत नाहीत त्यावेळी हिरण्य श्राद्ध घातले जाते. अनेक
                  वेळी यजमान परदेशी असू शकतात, वेळेअभावी अशी काही कारणे असू
                  शकतात. त्या वेळी फळे, कच्चे तांदूळ, डाळ साखर अश्या काही
                  गोष्टींचा उपयोग विधीमध्ये करता येतो.
                </p>
              </div>
            </div>

        
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>३. पावर्ण श्राद्ध</h4>
                <p>
                  पावर्ण याचा अर्थ होतो विशेष प्रसंग अथवा विशेष प्रसंगानुरूप. हा
                  विधी सर्व पितरांसाठी एकत्रित पणे करायचा असल्याने पितृपक्षात हे
                  श्राद्ध साधारणपणे शेवटच्या दिवशी अमावस्येला केले जाते. या मुळे
                  चुकून माकून आपल्या कडून राहून गेलेल्या व्यक्तिंस हि मुक्ती
                  मिळून जाते. या पूजेमुळे पितरांच्या आत्म्याला शांती लाभते व
                  घरातील सर्व अडथळे दूर होतात. कुटुंबातील सर्वांना आरोग्य, आनंद
                  व समृद्धी प्राप्त होऊन घरातील वातावरण मंगलमय होते.
                </p>
              </div>
            </div>

        
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>४. पिंडदान</h4>
                <p>
                  पिंडदान हा एक महत्वाचा विधी आहे, यात मृत आत्म्यास अन्न व जल
                  अर्पण केले जाते. तांदूळ, काळे तीळ व इतर धान्यांपासून बनवलेले
                  गोलाकार पिंड यावेळी अर्पण करतात. या पिंडास कावळा शिवणे
                  महत्वाचे मानले गेले आहे. जेणेकरून आपल्या पूर्वजांना मोक्ष
                  मिळेल. जन्मापासून सुरु झालेला प्रवास मोक्ष प्राप्तीपर्यंत
                  संपतो. हा प्रवास अधिक सुखकर मोक्षा पर्यंत पूर्ण व्हावा हा
                  हेतूने हे पिंडदान करतात .हे विधी मुलगा किंव्हा नातू च्या हातून
                  केले जातात.
                </p>
              </div>
            </div>

            <div className="col-lg-12 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>५. तर्पण</h4>
                <p>
                  फक्त हिंदू च नाही तर मानवता धर्मात देखील तहानलेल्या जीवास पाणी
                  दिल्याने पुण्य प्राप्र्त होते कारण समोरच्याचा आत्मा शांत होतो
                  व आपल्यास आपोआप च आशिर्वाद मिळतात. तर्पण हे पितृपक्षात
                  कोणत्याही दिवशी करू शकतो यामुळे आत्मा संतुष्ट होतो. यात
                  मुख्यत्वे उदक म्हणजेच जल व धान्य अर्पण केले जाते. पवित्र
                  गंगेचे जल किंव्हा शुध्द मनाने चांगल्या हेतूने पितरांचे तर्पण
                  केल्यास पितृदोषापासून हि मुक्ती मिळते असे म्हणतात.पितृ पक्ष हा
                  हिंदू धर्मातील अतिशय महत्वपूर्ण कालावधी आहे, ज्यामध्ये आपण
                  आपल्या पूर्वजांचे स्मरण करून त्यांना तर्पण, श्राद्ध आणि
                  पिंडदान या धार्मिक विधींनी आदरपूर्वक श्रद्धांजली अर्पण करतो.
                  या काळात असे मानले जाते की, पूर्वजांचे आत्मे पृथ्वीवर येतात
                  आणि आपल्या वंशजांकडून अर्पण केलेली अन्न-वस्त्रे-जल स्वीकारतात.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "0px",
          }}
        >
          <button
            type="submit"
            className="careox-btn button-webinar"
            onClick={() => HandleJoinNowClicked()}
          >
            <i
              className="fa-solid fa-user-plus"
              style={{ marginRight: "8px" }}
            ></i>
            <span> तातडीने नोंदणी करा</span>
          </button>
        </div>
      </section> */}
 

      <section className="shraddha-section info-pitrupaksh">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha pitrupaksha-headingcta align-left">
         Reserve your Ashtalakshmi Homam and invite <br></br>prosperity into your home.
          </h2>
          
          <button
            type="submit"
            onClick={() => HandleJoinNowClicked()}
            className="careox-btn cta-pitrupakshaone "
            style={{ marginTop: "20px" }}
          >
            <i
              className="fa-solid fa-user-plus"
              style={{ marginRight: "8px" }}
            ></i>
            <span className="pitrupakshabutone">Join Ashtalakshmi Homam
</span>
          </button>
        </div>
      </section>
      <section className="pitru-benefits-section py-12 main-colocr">
        <div className="pitru-container">
          <h2 className="pitru-benefits-title">Benefits
</h2>
         <div className="pitru-benefits-grid">
  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🪔</span>
    <h3 className="pitru-benefit-heading">Wealth and Prosperity:</h3>
    <p className="pitru-benefit-text">
      The primary benefit is attracting abundance, fulfilling all
      monetary desires, and improving financial stability.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🙏</span>
    <h3 className="pitru-benefit-heading">Success in Ventures:</h3>
    <p className="pitru-benefit-text">
      It bestows success in personal, professional, and business
      ventures opening new opportunities for growth.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🔱</span>
    <h3 className="pitru-benefit-heading">Wealth Protection:</h3>
    <p className="pitru-benefit-text">
      It helps protect against financial difficulties and recovers
      from losses, debts, and business failures.
    </p>
  </div>

  {/* ===================================== */}
  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">📿</span>
    <h3 className="pitru-benefit-heading">Knowledge and Wisdom:</h3>
    <p className="pitru-benefit-text">
      The homam blesses with knowledge, intellect, and academic
      excellence, improving one's wisdom and skills.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🔥</span>
    <h3 className="pitru-benefit-heading">Courage and Confidence:</h3>
    <p className="pitru-benefit-text">
      Worshippers gain courage and inner strength to face life's
      challenges and overcome impediments.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🕉️</span>
    <h3 className="pitru-benefit-heading">Spiritual Enlightenment:</h3>
    <p className="pitru-benefit-text">
      It strengthens the connection with the divine and deepens
      spiritual insight.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🌸</span>
    <h3 className="pitru-benefit-heading">Good Health:</h3>
    <p className="pitru-benefit-text">
      The ritual promotes good physical and emotional health and can
      provide relief from certain health issues.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🔔</span>
    <h3 className="pitru-benefit-heading">Peace and Harmony:</h3>
    <p className="pitru-benefit-text">
      It brings peace and harmony to the home and family, fostering
      positive relationships.
    </p>
  </div>

  <div className="pitru-benefit-card">
    <span className="pitru-benefit-icon">🧘</span>
    <h3 className="pitru-benefit-heading">
      Emotional and Mental Well-being:
    </h3>
    <p className="pitru-benefit-text">
      It helps clear the mind, removes negative influences, and
      provides mental calm and pleasure.
    </p>
  </div>
  
</div>
 <button
                  type="submit"
                  onClick={() => HandleJoinNowClicked()}
                  className="careox-btn pitru-button"
                >
                  <i
                    className="fa-solid fa-user-plus"
                    style={{ marginRight: "8px" }}
                  ></i>
                  <span className="pitrupakshabut">Book Now
</span>
                </button>
        </div>
      </section>

      <LazySection>
        <FAQSection languageID={3} />
      </LazySection>
      <footer className="footer">
  <div className="footer-container">
    {/* Left Side - Logo + Tagline */}
    <div className="footer-left">
      <img src={mainLogo} alt="Logo" className="footer-logo" />
      <p className="footer-tagline">Enhance Your Spiritual Journey</p>
    </div>

    {/* Right Side - Contact Info */}
    <div className="footer-right">
      <h3 className="footer-heading">Contact</h3>
      <p>
        <i className="fa-solid fa-phone" style={{ marginRight: "8px" }}></i>
        +91 91195 55461
      </p>
      <p>
        <i className="fa-solid fa-envelope" style={{ marginRight: "8px" }}></i>
        info@myomnamo.com
      </p>

      {/* Social Icons */}
      <div className="footer-social">
        <a href="#">
          <i className="fa-brands fa-facebook"></i>
        </a>
        <a href="#">
          <i className="fa-brands fa-instagram"></i>
        </a>
        <a href="#">
          <i className="fa-brands fa-youtube"></i>
        </a>
      </div>
    </div>
  </div>

  {/* Bottom Section */}
  <div className="footer-bottom">
    <p className="footer-bottomlink">
      © 2025 My Om Namo. All Rights Reserved.
    </p>
  </div>

  {/* Floating Buttons */}
  <div className="floating-buttons">
    <a href="#top" className="scroll-top">
      <i className="fa-solid fa-arrow-up"></i>
    </a>
    <a
      href="https://api.whatsapp.com/send/?phone=919975267711"
      target="_blank"
      className="whatsapp"
    >
      <i className="fa-brands fa-whatsapp"></i>
    </a>
  </div>
</footer>

      <ComingSoonModal
        show={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        moduleName="e-webinar"
      />
    </>
  );
};
export default AshtaLakshmiHomamWebinar;
